import { ReactElement } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { isPhoneDevice } from '@/utils/device';
import { useAuth } from '@/providers/AuthProvider';
import { useZoom } from '@/providers/ZoomProvider';
import MobileDeviceBlock from './MobileDeviceBlock';

const mobileAllowedPaths = [
  /^\/session\/[^/]+\/player(\/|$)/,
  /^\/privacy-policy(\/|$)/,
  /^\/zoom(\/|$)/
];

const isMobileAllowedPath = (pathname: string) =>
  mobileAllowedPaths.some((pattern) => pattern.test(pathname));

const MobileDeviceGate = (): ReactElement => {
  const location = useLocation();
  const { loaded, user } = useAuth();
  const zoom = useZoom();

  // `isPhoneDevice` is a viewport heuristic. Inside Zoom it produces false positives:
  // the meeting side panel is narrow even on a desktop client, so gating on width
  // would replace a working host experience with a "switch to desktop" message.
  // Zoom clients get the responsive layout instead of the block screen.
  const shouldBlock =
    loaded &&
    !!user &&
    !zoom.embedded &&
    isPhoneDevice() &&
    !isMobileAllowedPath(location.pathname);

  if (shouldBlock) {
    return <MobileDeviceBlock />;
  }

  return <Outlet />;
};

export default MobileDeviceGate;
